'use strict';

/**
 * Reads OneTrust consent from the OptanonConsent cookie.
 * Used by onetrust.js as the fallback when the live SDK (window.OneTrust) is absent,
 * so previously-given consent still applies.
 */

function readOptanonCookie() {
    const name = 'OptanonConsent=';
    const cookies = ('; ' + (document.cookie || '')).split('; ');
    for (const c of cookies) {
        if (c.indexOf(name) === 0) {
            return decodeURIComponent(c.substring(name.length));
        }
    }
    return null;
}

/** Returns true if the OptanonConsent cookie grants consent for the given group. */
export function hasConsent(group) {
    if (!group) {
        return false;
    }
    const raw = readOptanonCookie();
    if (!raw) {
        return false;
    }
    const groupsMatch = raw.match(/(?:^|&)groups=([^&]*)/);
    if (!groupsMatch) {
        return false;
    }
    for (const entry of groupsMatch[1].split(',')) {
        const parts = entry.split(':');
        if (parts[0] === group && parts[1] === '1') {
            return true;
        }
    }
    return false;
}
